<style lang="scss" scoped>
</style>
<template>
    <div>
        <jijiu-page-title title="司机管理">
            <div class="ml10">
                <el-button size="mini" type="primary" @click="add">添加司机</el-button>
            </div>
        </jijiu-page-title>
        <div class="mt10">
            <el-table size="mini"
                      border
                      :data="list"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="是否启用"
                    width="180">
                    <template slot-scope="{row}">
                        <span :class="row.status_class">{{row.status_text}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hosName"
                    label="所属医院"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="staffName"
                    label="司机姓名"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="staffIdcard"
                    label="身份证"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="staffMobile"
                    label="手机号"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="{row}">
                        <el-button type="text" size="mini" @click="startOrStop(row)">{{row.opera_btn}}</el-button>
                        <el-button type="text" size="mini" @click="modify(row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="mt10">
            <el-pagination
                background
                :page-size="page.pageSize"
                layout="total, prev, pager, next"
                :total="page.total"
                :current-page="page.pageNum"
                @current-change="getList">
            </el-pagination>
        </div>
        <add-driver-dialog ref="add"></add-driver-dialog>
    </div>
</template>
<script>
  import JijiuPageTitle from "../components/jijiu-page-title";
  import {staffService} from "../service/staff";
  import AddDriverDialog from "../components/add-driver-dialog";
  import {STAFF_DRIVER_STATUS} from "../config";
  import {STAFF_ADD_DRIVER_SUCCESS} from "../events";

  export default {
    name: 'jijiu-siji',
    components: {AddDriverDialog, JijiuPageTitle},
    data() {
      return {
        list: [],
        page: {
          pageSize: 10,
          pageNum: 1
        }
      }
    },
    created() {
      bus.$on(STAFF_ADD_DRIVER_SUCCESS.id, this.getList);
      this.getList();
    },
    beforeDestroy() {
      bus.$off(STAFF_ADD_DRIVER_SUCCESS.id, this.getList);
    },
    methods: {
      add() {
        this.$refs.add.show();
      },
      modify(data) {
        data.userMobile = data.staffMobile;
        this.$refs.add.show(data);
      },
      startOrStop(data) {
        this.$confirm(`是否${data.opera_btn} ${data.staffName}?`)
          .then(async () => {
            if (await staffService.startOrStopDriver(data.staffStatus === STAFF_DRIVER_STATUS.START_USING.id ? STAFF_DRIVER_STATUS.DICSONTINUE.id : STAFF_DRIVER_STATUS.START_USING.id, data.id)) {
              this.getList();
            }
          })
      },
      async getList(pageNum) {
        const {page: p} = this;

        const {list, page} = await staffService.listDriver({
          pageNo: parseInt(pageNum) || p.pageNum || 1,
          pageSize: p.pageSize
        });
        this.list = list;
        this.page = page;
      }
    },
  }
</script>
